import pricingImg11 from "../assets/newLeaserCutter/pricingImg11.png";
import pricingImg12 from "../assets/newLeaserCutter/pricingImg12.png";
import pricingImg13 from "../assets/newLeaserCutter/pricingImg13.png";
import pricingImg14 from "../assets/newLeaserCutter/pricingImg14.png";

import productImg11 from "../assets/newLeaserCutter/productImg11.png";
import productImg12 from "../assets/newLeaserCutter/productImg12.png";
import productImg13 from "../assets/newLeaserCutter/productImg13.png";

export default [
  {
    title: "Laser Cutting",
    description:
      "Our high power CO2 laser cutter machine can cut or engrave on any plastic, paper, wooden or organic material like leather, clothes etc easily upto 8mm thickness (depends on material). Laser cutting is very suitable for low cost mass production and even for low cost prototyping. Note that we don’t work with sheet metal yet.",
    features: [
      {
        name: (
          <p>
            Maximum cutting size:
            <br /> Regular cutting size:
          </p>
        ),
        value: [`35" x 40" (Full board order needed)`, "30” x 46”"],
      },
      {
        name: "Material type:",
        value: [
          `Plywood (upto 6mm)`,
          `PVC (upto 8mm)`,
          `Acrylic (Upto 8mm)`,
          `Wood (kerosin, balsa, maple, oak etc)`,
          `Leather`,
          `Jeans etc`,
        ],
      },
      {
        name: "Cutting tolerance:",
        value: "0.5mm",
      },
      {
        name: "Machine accuracy: ",
        value: "0.2mm",
      },
      {
        name: "Pricing scheme:",
        value: [`Cutting speed: 			15-30mm/s`, `Engraving(hatching)speed:	100mm/s`],
      },
      {
        name: "Designing standards",
        value: [
          `Color code:	Black = Line Cut`,

          <div>
            {" "}
            <b className="">Black </b> = Line Hatch (Engrave){" "}
          </div>,
          <div>
            {" "}
            <b className="text-primary">Blue </b> = Scanning engrave{" "}
          </div>,
          <div>
            {" "}
            <b className="text-danger">Red </b> = Line Cut{" "}
          </div>,
          `Minimum gap between two cutting lines: 1mm`,
        ],
      },
      {
        name: "Filetype",
        value: ".dxf, .pdf, .ai",
      },
    ],
    pricing: [
      {
        name: "Laser Cutting",
        image: pricingImg11,
        price: "18",
        unit: "/minute",
        buildTime: "Build Time: 1 Day",
        data: [
          <span>Wooden or plastic over 6mm</span>,
          <span>
            <b>
              Material price will be calculated as per our purchasing price.
            </b>
          </span>,
        ],
      },
      // {
      //   name: "Laser Cutting",
      //   image: pricingImg12,
      //   price: "2500",
      //   unit: "/hour",
      //   buildTime: "Build Time: 1 Day",
      //   data: [
      //     <span>Wooden or acrylic 3mm</span>,
      //     <span>
      //       <b>
      //         Material price will be calculated as per our purchasing price.
      //       </b>
      //     </span>,
      //   ],
      // },
      // {
      //   name: "Laser Cutting",
      //   image: pricingImg13,
      //   price: "2000",
      //   unit: "/hour",
      //   buildTime: "Build Time: 1 Day",
      //   data: [
      //     <span>PVC upto 1mm-3mm</span>,
      //     <span>
      //       <b>
      //         Material price will be calculated as per our purchasing price.
      //       </b>
      //     </span>,
      //   ],
      // },
      // {
      //   name: "Laser Cutting",
      //   image: pricingImg14,
      //   price: "1500",
      //   unit: "/hour",
      //   buildTime: "Build Time: 1 Day",
      //   data: [
      //     <span>hin material like paper, cloths etc</span>,
      //     <span>
      //       <b>
      //         Material price will be calculated as per our purchasing price.
      //       </b>
      //     </span>,
      //   ],
      // },
    ],
    notice: "",
    pricingCapabilites: [
      {
        name: "Pricing scheme:",
        value: [`Cutting speed: 30mm/s`, `Engraving(hatching)speed:	150mm/s`],
      },
      {
        name: "Designing standards",
        value: [
          `Color code:	Black = Line Cut`,
          `Red   = Line Hatch (Engrave)`,
          `Blue  =  Scanning engrave `,
          `Minimum gap between two cutting lines: 1mm`,
          `Maximum taper angle: 	5 degree`,
          `Average kerf width: 	0.25mm`,
        ],
      },
    ],
    products: [
      {
        name: "Item 1",
        image: productImg11,
        subheading: "Subheading",
      },
      {
        name: "Item 1",
        image: productImg12,
        subheading: "Subheading",
      },
      {
        name: "Item 1",
        image: productImg13,
        subheading: "Subheading",
      },
    ],
  },
];
